/**
 * Boje (tonovi) statusa dokumenata magacina za oznake `.wh-status--<ton>`: ok, warn, bad, info, accent, neutral.
 * Boja nikad nije jedini nosilac: uz nju uvek stoji naziv statusa.
 */
export const PURCHASE_STATUS_TONE = {
  created: "neutral",
  sent: "info",
  confirm: "ok",
  "confirm-half": "warn",
  "reject-supplier": "bad",
  "changed-in-progress": "warn",
  "waiting-to-other-supplier": "info",
  reject: "bad",
  delivered: "ok",
  "delivered-half": "warn",
  "on-checking": "info",
  "reject-on-arrived": "bad",
  accept: "ok",
  closed: "neutral",
  undefined: "neutral",
};

export const OFFER_STATUS_TONE = {
  pending: "warn",
  accepted: "ok",
  rejected: "bad",
  paid: "ok",
  unpaid: "warn",
};

/** Vrste transakcija magacina: naziv ide iz prevoda, ton i ikona su ovde. */
export const TRANSACTION_TYPES = {
  order: { key: "warehouse.purchase_order", tone: "accent", icon: "mdi-cart-arrow-down" },
  request: { key: "warehouse.request_quote", tone: "neutral", icon: "mdi-file-document-outline" },
  entry: { key: "warehouse.warehouse_replenishment", tone: "ok", icon: "mdi-package-variant-plus" },
  exit: { key: "warehouse.shipping_bill", tone: "info", icon: "mdi-truck-delivery-outline" },
  write_off: { key: "warehouse.write_off", tone: "bad", icon: "mdi-trash-can-outline" },
  return: { key: "warehouse.return", tone: "warn", icon: "mdi-backup-restore" },
};
